export default "__VITE_ASSET__8844ccc5__"